import React, { PureComponent, ReactNode } from 'react';
import classNames from 'classnames/bind';

import { IProps } from './types/box';
import style from './box.pcss';

class Box extends PureComponent<IProps> {

    cn = classNames.bind(style);

    render(): ReactNode {
        return (
            <div
                id={this.props.id}
                className={this.cn('box', {
                    'box_padding': this.props.padding
                }, this.props.className)}
                ref={this.props.refEl}
                style={this.props.style}
            >
                {this.props.title ? <h6 className={this.cn('box__title')}>{this.props.title}</h6> : null}
                {this.props.children}
            </div>
        );
    }

}

export default Box;
